import React from 'react';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import { ThomasCampaignProduct } from 'models/interfaces';

const GET_THOMAS_CAMPAIGN_PRODUCT = gql`
  query GetThomasCampaignProduct($product_id: Int!) {
    product: thomasCampaignProduct(product_id: $product_id) {
      product_id
      name
      abbreviation
      description
      created_date
      created_date
    }
    productAdServer: thomasCampaignProductAdServer(product_id: $product_id) {
      ad_server_id
    }
  }
`;

const LIST_THOMAS_CAMPAIGN_PRODUCTS_QUERY = gql`
  query ListThomasCampaignProduct {
    products: thomasCampaignProducts {
      product_id
      name
      abbreviation
      description
      created_date
      created_date
    }
  }
`;

interface ThomasCampaignProductContainerRenderProps {
  product: ThomasCampaignProduct;
  products: ThomasCampaignProduct[];
  adServerId: number;
}
interface ThomasCampaignProductResults {
  product: ThomasCampaignProduct;
  products: ThomasCampaignProduct[];
  productAdServer: any;
}


interface ThomasCampaignProductContainerProps {
  product_id?: number;
  children: (props: ThomasCampaignProductContainerRenderProps) => any;
}

const ThomasCampaignProductContainer: React.FunctionComponent<
  ThomasCampaignProductContainerProps
> = ({ product_id, children, ...props }) => {
  let query = LIST_THOMAS_CAMPAIGN_PRODUCTS_QUERY;

  if (product_id) {
    query = GET_THOMAS_CAMPAIGN_PRODUCT;
  }

  return (
    <Query<ThomasCampaignProductResults> query={query} variables={{ product_id }}>
      {({
        data: { product, productAdServer, products } = {
          product: {} as ThomasCampaignProduct,
          products: [] as ThomasCampaignProduct[],
          productAdServer: null
        },
        loading,
        refetch
      }) => {
        if (loading) {
          return null;
        }
        //YY - who put this refetch here?
        // refetch();
        return (
          children &&
          children({
            ...props,
            product,
            products,
            adServerId: productAdServer && productAdServer.ad_server_id
          })
        );
      }}
    </Query>
  );
};

export default ThomasCampaignProductContainer;
